import type { ReactNode } from "react";
import { cx } from "../cx";
import { type Column, DataTable } from "./DataTable";

/**
 * The Review rail's grid: chapter number, state, characters, cost. Fixed
 * 36px for the number and weighted fractions so "freigegeben" and "ZEICHEN"
 * fit at 300px; equal columns do not survive German.
 */
export const RAIL_TEMPLATE = "36px 1.4fr 1fr 0.8fr";

export interface RailTableProps<T> {
  columns: ReadonlyArray<Column<T>>;
  rows: ReadonlyArray<T>;
  rowKey: (row: T) => string;
  selectedKey?: string;
  onSelect?: (row: T) => void;
  rowTone?: (row: T) => "none" | "accent" | "warn" | "danger" | undefined;
  empty?: ReactNode;
  footer?: ReactNode;
  className?: string;
}

/** DataTable on the rail template, compact, mono data cells. */
export function RailTable<T>({ columns, className = "", ...rest }: RailTableProps<T>) {
  return (
    <DataTable
      {...rest}
      columns={columns.map((c) => ({ ...c, className: cx("font-mono text-data", c.className) }))}
      template={RAIL_TEMPLATE}
      density="compact"
      className={cx("[&_[data-row=body]]:text-ink-2", className)}
    />
  );
}
